import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Course } from '@lyceo/shared/plan/util-models';
import { Observable } from 'rxjs';
import { PLAN_CONFIG, PlanConfig } from '@lyceo/shared/plan/util-provider';

@Injectable({
  providedIn: 'root',
})
export class CourseService {
  private readonly planConfig: PlanConfig = inject<PlanConfig>(PLAN_CONFIG);
  private readonly http: HttpClient = inject(HttpClient);

  public getAll(pupilId: string): Observable<Course[]> {
    const url: string = `${this.planConfig.homiApiUrl}/api/pupils/${pupilId}/courses`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<Course[]>(url, {
      headers: headersToSend,
    });
  }
}
